import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { cn } from '../../utils/cn.esm.js';
import { LabelTag } from '../LabelTag/LabelTag.esm.js';
import dealIndicatorStyles from './DealIndicator.styles.esm.js';

const DEAL_INDICATOR_CONTENT = {
    great: "Great Price",
    good: "Good Price",
};
const DealIndicator = (_a) => {
    var { variant, attribution = false, inverse = false, className = "" } = _a, props = __rest(_a, ["variant", "attribution", "inverse", "className"]);
    const { container } = dealIndicatorStyles({ variant, inverse });
    const baseText = DEAL_INDICATOR_CONTENT[variant];
    const text = attribution ? `KBB ${baseText}` : baseText;
    return (jsx(LabelTag, Object.assign({ text: text, className: cn(container(), className) }, props)));
};
DealIndicator.displayName = "DealIndicator";

export { DealIndicator };
